import { Tag } from "antd";
import { FaUser } from "react-icons/fa";
import { MdLocationOn, MdWatchLater } from "react-icons/md";
import { BiSolidDollarCircle } from "react-icons/bi";
import config from "@/config";

function JobCard({ data, handleClick }) {
    const handleLink = () => {
        window.scroll({ top: 0, behavior: 'smooth' });
        handleClick(data.Pk);
    }
    return (
        <div onClick={handleLink}
            className=" flex gap-4 p-2 border-2 transition-all hover:border-primary-hover rounded-xl hover:shadow-lg hover:-translate-y-1 cursor-pointer">
            <div className="w-24 h-24 shrink-0 border border-primary p-1 rounded-lg">
                <img className="w-full h-full object-contain"
                    src={`/${data.PhotoCompany}` || config.webConfig.logo} alt="Job Logo" />
            </div>
            <div className="w-3/4 gap-1 flex justify-between flex-col ">
                <div className="text-base font-bold line-clamp-1">{data.JobTitle}</div>
                <div className="flex gap-2 flex-wrap">
                    <Tag color={"blue"} className="flex m-0  gap-1 items-center">
                        <MdLocationOn className="w-3 h-3" />
                        <p>Hà nội</p>
                    </Tag>
                    <Tag color={"blue"} className="flex m-0  gap-1 items-center">
                        <BiSolidDollarCircle className="w-3 h-3" />
                        <p>{data.JobSalary}</p>
                    </Tag>
                    <Tag color={"blue"} className="flex m-0  gap-1 items-center">
                        <FaUser className="w-3 h-3" />
                        <p>Số lượng vị trí: {data.JobQuantity}</p>
                    </Tag>
                </div>
                <div className="flex justify-end">
                    <Tag color={"yellow"} className="flex gap-1 items-center">
                        <MdWatchLater className="w-3 h-3" />
                        <p>Ngày chốt hồ sơ: {data.DeadLine}</p>
                    </Tag>
                </div>
            </div>
        </div>
    );
}

export default JobCard;